import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { ConfirmationService } from 'primeng-lts/api';

import { ConfirmService } from './confirm.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html'
})
export class ConfirmComponent implements OnInit, OnDestroy {

  confirmPopupSubscription?: Subscription;
  confirmDialogSubscription?: Subscription;

  constructor(
    private confirmationService: ConfirmationService,
    private confirmService: ConfirmService
  ) {
  }

  ngOnInit(): void {
    this.confirmPopupSubscription = this.confirmService.getConfirmPopup().subscribe((event) => {
      if (event && event.target) {
        this.confirmationService.close();
        setTimeout(() => {
          this.confirmationService.confirm({
            target: event.target,
            message: event.message,
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Có',
            rejectLabel: 'Đóng',
            accept: event.accept,
            key: 'confirmPopup'
          });
        }, 200);
      }
    });
    this.confirmDialogSubscription = this.confirmService.getConfirmDialog().subscribe((confirmation) => {
      if (confirmation) {
        this.confirmationService.close();
        setTimeout(() => {
          // keepLabels = true: giữ nguyên acceptLabel/rejectLabel do caller truyền vào.
          // Mặc định (không truyền) vẫn ép về 'Có'/'Không' như hành vi cũ để không ảnh hưởng các dialog hiện có.
          const keepLabels = confirmation.keepLabels === true;
          const conf = Object.assign({}, confirmation, {
            key: 'confirmDialog'
          });
          if (!keepLabels) {
            conf.acceptLabel = 'Có';
            conf.rejectLabel = 'Không';
          }
          delete conf.keepLabels;
          this.confirmationService.confirm(conf);
        }, 200);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.confirmPopupSubscription) {
      this.confirmPopupSubscription.unsubscribe();
    }
    if (this.confirmDialogSubscription) {
      this.confirmDialogSubscription.unsubscribe();
    }
  }

}
